import { useEffect } from "react";
import CheckCircleIcon from "../icons/CheckCircleIcon";
import CloseCircleIcon from "../icons/CloseCircleIcon";

const ModalAlert = ({ isOpen, type, closeModal, message, timeout }) => {
	useEffect(() => {
		let timer;
		if (isOpen && timeout) {
			timer = setTimeout(() => {
				closeModal();
			}, timeout);
		}
		return () => clearTimeout(timer);
	}, [isOpen, timeout, closeModal]);

	if (!isOpen) return null;
	const modalStyles = {
		error: {
			title: "AN ERROR OCCURRED",
			titleColor: "text-red-600",
			message: message ? message : "Something went wrong.",
			buttonText: "Try again",
			buttonColor: "bg-red-600 hover:bg-red-700",
			icon: CloseCircleIcon,
		},
		success: {
			title: "SUCCESS",
			titleColor: "text-green-500",
			message: message ? message : "The process was successful.",
			buttonText: "Close",
			buttonColor: "bg-green-600 hover:bg-green-700",
			icon: CheckCircleIcon,
		},
	};

	const currentStyles = modalStyles[type] || modalStyles.error;
	const IconComponent = currentStyles.icon;

	return (
		<div
			id="modalAlert"
			tabIndex="-1"
			aria-hidden="true"
			className="fixed inset-0 top-0 right-0 left-0 z-[9999] flex h-full w-full items-center justify-center overflow-y-auto overflow-x-hidden bg-dark-blue bg-opacity-70 p-2 sm:p-4"
		>
			<div className="relative max-h-full w-full min-w-[260px] max-w-[90%] sm:max-w-md md:max-w-lg lg:max-w-xl">
				<div className="relative rounded-lg bg-navbar-bg p-4 shadow-lg sm:p-6 md:p-8">
					<button
						type="button"
						className="absolute top-2 right-2 rounded-lg bg-transparent p-1 text-gray-400 hover:bg-gray-800 hover:text-white sm:top-3 sm:right-3"
						onClick={closeModal}
						aria-hidden="false"
					>
						<svg
							aria-hidden="true"
							className="h-4 w-4 sm:h-5 sm:w-5"
							fill="currentColor"
							viewBox="0 0 20 20"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fillRule="evenodd"
								d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
								clipRule="evenodd"
							/>
						</svg>
						<span className="sr-only">Close modal</span>
					</button>

					<div className="flex flex-col items-center text-center">
						<IconComponent
							className={`${currentStyles.titleColor} h-7 w-7 sm:h-8 sm:w-8 md:h-10 md:w-10`}
						/>
						<h3
							className={`font-semibold text-base sm:text-lg md:text-xl ${currentStyles.titleColor} mt-3 text-gray-200 sm:mt-4`}
						>
							{currentStyles.title}
						</h3>
						<p className="mt-2 mb-4 px-2 text-gray-400 text-xs sm:mb-5 sm:px-4 sm:text-sm md:px-6 md:text-base">
							{currentStyles.message}
						</p>
						<button
							type="button"
							className={`text-white ${currentStyles.buttonColor} rounded-lg px-4 py-2 font-medium text-xs focus:outline-none focus:ring-4 focus:ring-opacity-50 sm:px-5 sm:py-2.5 sm:text-sm md:text-base`}
							onClick={closeModal}
						>
							{currentStyles.buttonText}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ModalAlert;
